import { PBV3RewardClaimStatus } from "interfaces";
import moment, { Moment } from "moment";

interface EventTimes {
	eventInProgress: boolean;
	eventEnded: boolean;
	saleEnded: boolean;
}

export const toTimeMs = (value: unknown): number => {
	if (moment.isMoment(value)) {
		return value.valueOf();
	}

	if (
		typeof value === "string" ||
		typeof value === "number" ||
		value instanceof Date
	) {
		return new Date(value).getTime();
	}

	return NaN;
};

export const getEventTimes = (now: Moment | null, end: Moment): EventTimes => {
	const diff = moment.duration(end.diff(now));

	return {
		eventInProgress: moment(now).isBefore(end),
		eventEnded: diff.days() < 0,
		saleEnded: diff.hours() <= 0
	};
};

export const getUncollectedRewards = (
	rewards: PBV3RewardClaimStatus[],
	userLoyaltyPoints: number
): PBV3RewardClaimStatus[] => {
	const uncollectedRewards: PBV3RewardClaimStatus[] = [];
	rewards.forEach((rewardItem) => {
		const { reward, isClaimed } = rewardItem;
		if (reward.loyaltyPoints <= userLoyaltyPoints) {
			if (!isClaimed) {
				uncollectedRewards.push(rewardItem);
			}
		}
	});
	return uncollectedRewards;
};
